import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

const inputCls = "mt-2 w-full border border-white/15 bg-ink px-4 py-3 text-white placeholder:text-zinc-500 focus:border-volt focus:outline-none transition-colors";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden bg-ink px-5" data-testid="admin-login-page">
      <p aria-hidden className="pointer-events-none absolute -bottom-[8vw] -right-[4vw] select-none font-display text-[50vw] font-black leading-none text-outline">77</p>
      <form onSubmit={submit} className="relative w-full max-w-md border border-white/10 bg-surface p-8 md:p-10" data-testid="admin-login-form">
        <LogoMark className="h-8 w-auto" />
        <h1 className="mt-8 font-display text-5xl font-black uppercase leading-none">Area riservata</h1>
        <p className="mt-3 text-sm text-zinc-400">Accedi per aggiornare risultati, calendario, news, galleria e sponsor.</p>
        <label className="mt-8 block">
          <span className="label-mono text-zinc-400">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" />
        </label>
        <label className="mt-5 block">
          <span className="label-mono text-zinc-400">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" />
        </label>
        {error && <p className="mt-4 text-sm text-flag" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-8 flex w-full items-center justify-center gap-2 bg-trident py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-white transition-opacity hover:opacity-90 disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Accedi
        </button>
        <Link to="/" className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-400 hover:text-white" data-testid="admin-login-back">
          <ArrowLeft className="h-4 w-4" /> Torna al sito
        </Link>
      </form>
    </div>
  );
}
